import { createSelector } from 'selectors'

import { DetailComponents } from './actionPlanner'
import { actionPlanner } from './constant'

const { selectors } = actionPlanner

const getDetailEditSwitcher = (scope: HTMLElement) =>
	createSelector<HTMLSelectElement>({ scope, selector: selectors.actionPlannerEditorSwitchModeButton })

const getDetailEditComponents = (scope: HTMLElement) =>
	createSelector<NodeListOf<HTMLSelectElement>>({ scope, selector: selectors.actionPlannerEditorEditComponent }, true)

const getDetailViewComponents = (scope: HTMLElement) =>
	createSelector<NodeListOf<HTMLSelectElement>>({ scope, selector: selectors.actionPlannerEditorViewComponent }, true)

export const getDetailScopesSelector = () =>
	createSelector<NodeListOf<HTMLSelectElement>>({ selector: selectors.actionPlannerDetail }, true)

export const getEditorComponents = (scope: HTMLElement): DetailComponents => ({
	actionPlannerDetailEditSwitcher: getDetailEditSwitcher(scope),
	actionPlannerDetailEditComponents: getDetailEditComponents(scope),
	actionPlannerDetailViewComponents: getDetailViewComponents(scope),
})
